/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React from 'react';
import {Text, StyleSheet, SafeAreaView, Pressable } from 'react-native';
import { Icon } from 'react-native-elements';
import { LinearGradient } from 'expo-linear-gradient';


const Locked = (props) => {
return (
<LinearGradient
colors={['black', '#590000']}
locations={[.1,1]}
style={{flex: 1}}
>
<SafeAreaView style={styles.locked}>
<Icon
style={styles.lockedIcon}
name='lock'
type='MaterialCommunityIcons'
color='lightgray'
size={80}
/>
<Text style={styles.lockedText}>The content you are trying to access is restricted.</Text>
<Text style={styles.lockedText}>Please return to the home page.</Text>
<Pressable
style={styles.lockedButton}
onPress={() => props.onPress()}>
<Text style={styles.lockedText}>Home</Text>
</Pressable>
</SafeAreaView>
</LinearGradient>
)
}

const styles = StyleSheet.create({
locked: {
 flex: 1,
 flexDirection: 'column',
 justifyContent: 'center',
 },
 lockedIcon: {
 marginBottom: 10,
 },
 lockedText: {
 color: 'white',
 textAlign: 'center',
 },
 lockedButton: {
 backgroundColor: '#00000000',
 marginLeft: 30,
 marginRight: 30,
 marginTop: 20,
 height: 48,
 borderRadius: 5,
 alignItems: "center",
 justifyContent: 'center',
 alignSelf: 'center',
 width: 100,
 borderTopColor: '#cccccc',
 borderBottomColor: '#cccccc',
 borderLeftColor: '#cccccc',
 borderRightColor: '#cccccc',
 borderTopWidth: 1,
 borderBottomWidth: 1,
 borderLeftWidth: 1,
 borderRightWidth: 1,
 },
});

export default Locked;